import { FC, useState } from 'react';
import { EditIcon, InvoicesTabIcon, ListActionsIcon } from 'assets/icons';
import { PortalPopover } from 'components';
import { PopoverArrowTypes } from 'constants/common';

interface CustomerRowActionsProps {
  onEditCustomer: () => void;
  onNewInvoice: () => void;
  showEdit: boolean;
  showNewInvoice: boolean;
}

const CustomerRowActions: FC<CustomerRowActionsProps> = ({
  onEditCustomer,
  onNewInvoice,
  showEdit,
  showNewInvoice
}) => {
  const [showActionsPopover, setShowActionsPopover] = useState(false);

  const actionsButton = ({ isPanelOpen }: { isPanelOpen: boolean }) => (
    <button className="z-20 rounded-full p-2 hover:bg-gray-100">
      <ListActionsIcon />
    </button>
  );

  const handleEditClick = () => {
    onEditCustomer();
    setShowActionsPopover(false);
  };

  const handleNewInvoiceClick = () => {
    onNewInvoice();
    setShowActionsPopover(false);
  };

  return (
    <PortalPopover
      anchorComponent={actionsButton}
      show={showActionsPopover}
      onTogglePopover={() => setShowActionsPopover(!showActionsPopover)}
      onClosePopover={() => setShowActionsPopover(false)}
      highlightAnchor={false}
      offset={{ right: 0, top: 30 }}
      padding="p-2"
      width="w-[200px]"
      minWidth="min-w-[200px]"
      showArrow={false}
      arrowType={PopoverArrowTypes.TOP}>
      <div className="flex flex-col gap-1">
        {showEdit && (
          <button
            className="flex items-center gap-3 rounded-md px-3 py-2.5 text-left hover:bg-gray-100"
            onClick={handleEditClick}>
            <EditIcon className="path-fill-current path text-secondary" />
            <span className="text-sbase font-medium text-primaryText">Edit</span>
          </button>
        )}
        {showNewInvoice && (
          <button
            className="flex items-center gap-3 rounded-md px-3 py-2.5 text-left hover:bg-gray-100"
            onClick={handleNewInvoiceClick}>
            <InvoicesTabIcon className="path-stroke-current path ml-0.5 mr-1 font-bold text-primaryBtn" />
            <span className="text-sbase font-medium text-primaryText">New Invoice</span>
          </button>
        )}
      </div>
    </PortalPopover>
  );
};

export default CustomerRowActions;
